import { Component, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Table } from 'primeng/table';
import { forkJoin } from 'rxjs';
import { flatMap, map, mergeMap } from 'rxjs/operators';
import { checkFieldsValidity } from '../../shared/index';
import { feeTypeConst, loanTypeConst, typeOfSaleConst } from '../auctionFees.const';
import { ManageAuctionFeesService } from '../manage-auction-fees.service';
import { AuctionFeesSearch, AuctionFeetype } from '../models/AuctionFees';

@Component({
  selector: 'app-list-auction-fees',
  templateUrl: './list-auction-fees.component.html',
  styleUrls: ['./list-auction-fees.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ListAuctionFeesComponent implements OnInit {

  @Output() doeditBidInstructionEvent = new EventEmitter<boolean>();
  @Output() selectedAuctionFees = new EventEmitter<{}>();
  @Output() setBreadCrumbs = new EventEmitter<any[]>();

  @ViewChild('dt') table: Table;

  //listAuctionFeesForm: FormGroup;
  data: AuctionFeetype[];
  selectedItems: AuctionFeetype[];
  formSubmitted: boolean = false;
  searchParams: any;
  records: any;
  loadingSearchResult: boolean = true;
  cols: { field: string; header: string; showInHeader: boolean; }[];
  loanType = loanTypeConst;
  typeOfSale = typeOfSaleConst;
  feeType = feeTypeConst;
  feeAmount: string;
  currentPageSlectedItems: any[];
  selectedClientId: any[];
  selectedLoanType: any[];
  selectedTypeOfSale:  any[];
  selectedFeeType: any;
  clientId :any[];
  localStorageData:any;

  public listAuctionFeesForm = new FormGroup({
    ClientId: new FormControl('', null),
    LoanType: new FormControl('', null),
    TypeOfSale: new FormControl('', null),
    FeeType: new FormControl('', null),
    FeeAmount: new FormControl('',  Validators.pattern(/^[0-9]\d*(\.\d*)?$/))
  }, checkFieldsValidity(Validators.required));

  clientIdControl = this.listAuctionFeesForm.get('ClientId');
  loanTypeControl = this.listAuctionFeesForm.get('LoanType');
  typeOfSaleControl = this.listAuctionFeesForm.get('TypeOfSale');
  feeTypeControl = this.listAuctionFeesForm.get('FeeType');
  feeAmountControl = this.listAuctionFeesForm.get('FeeAmount');

  constructor(private manageAuctionFeesService : ManageAuctionFeesService) { }

  ngOnInit() {
    this.localStorageData =  JSON.parse(localStorage.getItem("dataSearchParams"));
    let clientArray = [],typeOfSaleArray = [], loanTypeArray = [], feeTypeArray = [];
    this.manageAuctionFeesService.getUniqueClientID().subscribe(res =>{
      this.clientId = res.data;
      if(this.localStorageData != null){
          this.localStorageData.Client.split(",").map((item) => {clientArray.push(item.trim())});
          this.localStorageData.TypeOfSale.split(",").map((item) => {typeOfSaleArray.push(item.trim())});
          this.localStorageData.LoanType.split(",").map((item) => {loanTypeArray.push(item.trim())});
          this.localStorageData.FeeType.split(",").map((item) => {feeTypeArray.push(item.trim())});
          this.selectedClientId = this.clientId.filter(a => clientArray.indexOf(a.value.toString()) !== -1).map(a => a.value);
          this.selectedTypeOfSale = this.typeOfSale.filter(a => typeOfSaleArray.indexOf(a.value.toString()) !== -1).map(a => a.value);
          this.selectedLoanType = this.loanType.filter(a => loanTypeArray.indexOf(a.value.toString()) !== -1).map(a => a.value);
          this.selectedFeeType = this.feeType.filter(a => feeTypeArray.indexOf(a.value.toString()) !== -1).map(a => a.value);
          this.feeAmount =  this.localStorageData.FeeAmount;
        }
    });

    this.formSubmitted =  false;
    this.loadingSearchResult = false;
    this.cols = [
      { field: 'AuctionFeesMatrixId', header: 'Auction Fees Matrix Id', showInHeader: false },
      { field: 'UniqueClientID', header: 'Unique Client ID', showInHeader: true },
      { field: 'LoanType', header: 'Loan Type', showInHeader: true },
      { field: 'TypeOfSale', header: 'Type of Sale', showInHeader: true },
      { field: 'FeeType', header: 'Fee Type', showInHeader: true },
      { field: 'FeeAmount', header: 'Fee Amount', showInHeader: true },
      { field: 'action', header: 'Action', showInHeader: true }
    ];

    if(this.localStorageData != null) {
     this.getData(JSON.parse(localStorage.getItem("dataSearchParams")));
    }
  }

  onTableHeaderCheckboxToggle = (event) =>{
    let startRow = this.table.first;
    let range = startRow + (this.table.rows);
    this.currentPageSlectedItems = [];
    this.data.map((item, index) => {
      if (index >= startRow && index < range) {
        this.currentPageSlectedItems.push(item);
      }
    })
    this.selectedItems = [];
    this.selectedItems = this.currentPageSlectedItems;
  }

  resetSelections = (e) =>{
    this.selectedItems = [];
  }

  isPaginatorVisible = (): boolean => {
    return (this.data && this.data.length > 0) ? true : false;
  }

  resetForm = () => {
    this.formSubmitted =  false;
    this.listAuctionFeesForm.reset();
    this.data = [];
    localStorage.clear();
  }

  onSubmitListAuctionFeesForm() : void {
    this.setSearchParams();
    this.getData(this.searchParams);
  }
  
  getData(params){
    this.formSubmitted =  true;
    this.loadingSearchResult = true;
    this.data = [];
    this.selectedItems = [];
    if(this.table){
      this.table.first = 0;
    }
    this.manageAuctionFeesService.getAuctionFeesData(params).subscribe(response=>{
      this.data = response.data;
      this.records =  response.meta.pagination.TotalRecords;
      this.loadingSearchResult = false;
    });
  }

  setSearchParams(): void {
    this.searchParams = <AuctionFeesSearch>{};
    this.searchParams.Client = this.clientIdControl.value == (null || undefined) ? '' : this.clientIdControl.value.toString();
    this.searchParams.LoanType = this.loanTypeControl.value == (null || undefined) ? '' : this.loanTypeControl.value.toString();
    this.searchParams.TypeOfSale = this.typeOfSaleControl.value == (null || undefined) ? '' : this.typeOfSaleControl.value.toString();
    this.searchParams.FeeType = this.feeTypeControl.value == (null || undefined) ? '' : this.feeTypeControl.value.toString();
    this.searchParams.FeeAmount = this.feeAmountControl.value == (null || undefined) ? '' : this.feeAmountControl.value.toString();
    localStorage.setItem("dataSearchParams", JSON.stringify(this.searchParams));
  }

  showEditAuctionFees(data: AuctionFeetype): any {
    this.doeditBidInstructionEvent.emit(true);
    this.selectedAuctionFees.emit(data);
    this.setBreadCrumbs.emit([{label: 'Manage Auction Fees' },{ label: 'Edit Auction Fees'}]);
  } 

  deleteSelected = () : void => {
    const matrixIds = this.selectedItems.map((arrayObject)=>{return arrayObject.AuctionFeesMatrixId}).join(",");
    this.manageAuctionFeesService.delete(matrixIds).subscribe(res => {
      let result =  res.data[0];
      if(result.STATUS == 'Success' && result.NUMBEROFRECORDSDELETED > 0){
        this.onSubmitListAuctionFeesForm();
      }
    },error=>{
      console.log(error.message);
    });
  }

}
